// import ThryvHubspot_HvacForm from './HvacForm';

var ThryvHubspot_EventListeners = new Object();

ThryvHubspot_EventListeners.version = "1.0.0";

ThryvHubspot_EventListeners.init = function (formId, eventName, eventData) {
  var _this = this;

  // ThryvHubspot_HvacForm.init(formId, eventName, eventData);
};

ThryvHubspot_EventListeners.listen = function () {
  var _this = this;

  window.addEventListener("message", function (event) {
    var eventData = event.data;

    // console.log('ThryvHubspot_EventListeners.listen event', event);
    // console.log('ThryvHubspot_EventListeners.listen eventData', eventData);

    if (
      typeof eventData !== "object" ||
      eventData === null ||
      eventData.type !== "hsFormCallback" ||
      !eventData.id ||
      !eventData.eventName
    ) {
      return;
    }

    var formId = eventData.id;
    var eventName = eventData.eventName;

    // console.log('ThryvHubspot_EventListeners.listen event', event);
    // console.log('ThryvHubspot_EventListeners.listen eventName', eventName);

    if (
      ["onFormReady", "onFormSubmit", "onBeforeFormSubmit", "onFormSubmitted"].includes(eventName)
    ) {
      _this.init(formId, eventName, eventData);
    }
  });
};

export default ThryvHubspot_EventListeners;
